import type { BrandingColors } from '../types/branding.types'

interface PalettePreviewProps {
  title: string
  colors: BrandingColors
  displayName: string
}

const hsl = (value: string) => `hsl(${value})`

// Mostra como a paleta fica numa tela de aviso, usando só as cores escolhidas (sem depender do tema atual).
export function PalettePreview({ title, colors, displayName }: PalettePreviewProps) {
  return (
    <figure
      aria-label={`Prévia: ${title}`}
      className="overflow-hidden rounded-2xl border"
      style={{
        backgroundColor: hsl(colors.background),
        color: hsl(colors.foreground),
        borderColor: hsl(colors.border),
      }}
    >
      <figcaption className="px-4 pt-3 text-sm font-medium">{title}</figcaption>
      <div className="space-y-3 p-4">
        <div
          className="space-y-2 rounded-xl border p-4"
          style={{
            backgroundColor: hsl(colors.card),
            color: hsl(colors.cardForeground),
            borderColor: hsl(colors.border),
          }}
        >
          <p className="text-base font-semibold">{displayName || 'Sua organização'}</p>
          <p className="text-sm" style={{ color: hsl(colors.mutedForeground) }}>
            Novo horário de funcionamento a partir de segunda.
          </p>
          <div className="flex flex-wrap gap-2">
            <span
              className="rounded-lg px-3 py-2 text-sm font-medium"
              style={{ backgroundColor: hsl(colors.primary), color: hsl(colors.primaryForeground) }}
            >
              Li e estou ciente
            </span>
            <span
              className="rounded-lg px-3 py-2 text-sm font-medium"
              style={{
                backgroundColor: hsl(colors.secondary),
                color: hsl(colors.secondaryForeground),
              }}
            >
              Ver depois
            </span>
            <span
              className="rounded-lg px-3 py-2 text-sm font-medium"
              style={{
                backgroundColor: hsl(colors.destructive),
                color: hsl(colors.destructiveForeground),
              }}
            >
              Apagar
            </span>
          </div>
        </div>
        <p
          className="rounded-lg px-3 py-2 text-sm"
          style={{ backgroundColor: hsl(colors.accent), color: hsl(colors.accentForeground) }}
        >
          Destaque: precisa da sua ciência
        </p>
        <p
          className="rounded-lg px-3 py-2 text-sm"
          style={{ backgroundColor: hsl(colors.muted), color: hsl(colors.mutedForeground) }}
        >
          Informação de apoio em fundo suave
        </p>
      </div>
    </figure>
  )
}
